import { PdfQuestionnaireBoundary } from "./PdfQuestionnaireBoundary";
import { PdfQuestionnaireForm } from "./PdfQuestionnaireForm";

export const PdfQuestionnaireFilled = () => (
  <PdfQuestionnaireBoundary>
    {(data) => (
      <PdfQuestionnaireForm initialAnswerItems={(data.questionnaireAnswers ?? []).flatMap((qa) => qa.questionnaireAnswerItems ?? [])} />
    )}
  </PdfQuestionnaireBoundary>
);
